import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { NgIf } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'report-list-owner-header',
    standalone: true,
    imports: [NgIf],
    template: `
        <div class="owner-header-container" (click)="onSortRequested($event)">
            <i class="pi pi-user"></i>
            <div class="ag-header-cell-label">
                <!-- <span class="ag-header-icon ag-header-label-icon ag-sort-order" ref="eSortOrder"></span>
                <span class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" ref="eSortAsc"></span>
                <span class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" ref="eSortDesc"></span>
                <span class="ag-header-icon ag-header-label-icon ag-sort-none-icon" ref="eSortNone"></span> -->
                <span class="ag-sort-indicator-container" ref="eSortIndicator">
                    <!-- <span *ngIf="params.enableSorting && params.column.getSortIndex()" ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order">{{params.column.getSortIndex()}}</span> -->
                    <span *ngIf="params.enableSorting && params.column.isSortAscending()" ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon"><span class="ag-icon ag-icon-asc" unselectable="on" role="presentation"></span></span>
                    <span *ngIf="params.enableSorting && params.column.isSortDescending()" ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon"><span class="ag-icon ag-icon-desc" unselectable="on" role="presentation"></span></span>
                    <!-- <span *ngIf="params.enableSorting" ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon"><span class="ag-icon ag-icon-none" unselectable="on" role="presentation"></span></span> -->
                    <!-- <span *ngIf="params.enableSorting" ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon"><span class="ag-icon ag-icon-none" unselectable="on" role="presentation"></span></span> -->
                </span>
            </div>
        </div>
    `,
    styles: [
        `
            .owner-header-container {
                display: flex;
                align-items: center;
                cursor: pointer;
                min-width: 34.5px;
            }

            .ag-header-cell-label {
                display: flex;
                align-items: center;
                margin-left: auto;
            }
        `
    ]
})
export class OwnerHeaderComponent implements IHeaderAngularComp {
    public params!: IHeaderParams;
    public sortIcon = '';

    public agInit(params: IHeaderParams): void {
        this.params = params;
    }

    public onSortRequested(event: any) {
        this.params.progressSort(event.shiftKey);
    }

    public refresh(params: IHeaderParams): boolean {
        return true;
    }
}
